import React from 'react';
import StepIndicator from './StepIndicator';
import { Icon } from '../../../elements/icon';
import { useTranslation } from 'react-i18next';

function FinalScreen({ state, message, onClose, onRestart }) {
  const { t } = useTranslation();
  const isCancelled = state === 'cancelled';
  const isSaved = state === 'saved';
  const isRestarted = state === 'restarted';

  const titleHtml = isCancelled
    ? `${t('CancelFlow_Final_Cancelled_Title_Line1')}<br/><em className="!t-text-secondary">${t(
        'CancelFlow_Final_Cancelled_Title_Line2',
      )}</em>`
    : isSaved
      ? message.title
      : t('CancelFlow_Final_Reactivated_Title');

  const subtitle =
    isCancelled && !isSaved && !isRestarted
      ? t('CancelFlow_Final_Cancelled_Subtitle')
      : isSaved
        ? message.body
        : t('CancelFlow_Final_Reactivated_Subtitle');

  return (
    <>
      <StepIndicator step={3} onBack={() => {}} showBack={false} />

      <div className="t-w-16 t-h-16 t-rounded-full t-border-2 t-border-teal-mid t-bg-teal-bg t-flex t-items-center t-justify-center t-mx-auto t-mb-2">
        <span className="t-text-secondary t-text-2xl">
          <Icon name="tickBorderCircle" size={28} color="#005d67" className="t-mt-2" />
        </span>
      </div>

      <div className="t-text-center">
        <h2
          className="t-text-[22px] t-font-serif t-text-slate-900 t-mb-2"
          dangerouslySetInnerHTML={{ __html: titleHtml }}
        />
        <p className="t-text-sm t-text-slate-600 t-max-w-xs t-mx-auto t-m-0">{subtitle}</p>
      </div>

      {isCancelled && (
        <div className="t-bg-slate-50 t-border-[1.5px] t-border-teal-mid t-rounded-xl t-px-4 t-py-2 t-mt-2">
          <div className="t-flex t-items-center t-justify-between t-py-2">
            <span className="t-text-xs t-text-slate-600">{t('CancelFlow_Final_Status')}</span>
            <span className="t-inline-flex t-items-center t-justify-center t-rounded-full t-border t-border-red-200 t-bg-red-50 t-text-[11px] t-font-semibold t-text-red-700 t-px-3 t-py-0.5">
              {t('CancelFlow_Final_Status_Cancelled')}
            </span>
          </div>
          <div className="t-h-px t-bg-teal-mid" />
          <div className="t-flex t-items-center t-justify-between t-py-2">
            <span className="t-text-xs t-text-slate-600">{t('CancelFlow_Final_FormulaSaved')}</span>
            <span className="t-text-xs t-font-medium t-text-slate-800">
              {t('CancelFlow_Final_FormulaSaved_Value')}
            </span>
          </div>
          <div className="t-h-px t-bg-teal-mid" />
          <div className="t-flex t-items-center t-justify-between t-py-2">
            <span className="t-text-xs t-text-slate-600">{t('CancelFlow_Final_RestartAnytime')}</span>
            <span className="t-text-xs t-font-medium t-text-slate-800">
              {t('CancelFlow_Final_RestartAnytime_Value')}
            </span>
          </div>
        </div>
      )}

      <button
        type="button"
        onClick={onClose}
        className="t-w-full t-inline-flex t-items-center t-justify-center t-rounded-xl t-px-4 t-py-3 t-bg-secondary t-text-white t-font-semibold t-text-sm t-gap-2 t-shadow-sm hover:t-shadow-[0_4px_12px_rgba(26,107,90,0.28)]  t-transition t-mt-4"
      >
        {t('CancelFlow_Final_GoToDashboard')}
      </button>

      {/* {isCancelled && (
        <button
          type="button"
          onClick={onRestart}
          className="t-text-sm t-text-secondary t-underline t-underline-offset-2 t-text-center t-mt-1"
        >
          {t('CancelFlow_Final_RestartButton')}
        </button>
      )} */}
    </>
  );
}

export default FinalScreen;
